import { processBankStatementRequest } from "./bank-statement-upload/processBankStatementRequest";
import { UploadStatus } from "./enums/uploadStatus";
import type { UploadedFile } from "./BankStatementUpload";

type FilePatch = Partial<
  Pick<UploadedFile, "progress" | "status" | "errorMessage">
>;

type UploadBankStatementParams = {
  file: UploadedFile;
  onPatch: (fileId: string, patch: FilePatch) => void;
  onIdGenerated: (fileId: string, documentId: string) => void;
  errorMessage: string;
};

type UploadBankStatementResult = {
  succeeded: boolean;
};

export const uploadBankStatement = async ({
  file,
  onPatch,
  onIdGenerated,
  errorMessage,
}: UploadBankStatementParams): Promise<UploadBankStatementResult> => {
  if (file.status !== UploadStatus.PENDING) {
    return { succeeded: true };
  }

  try {
    await processBankStatementRequest({
      uploadedFile: file,
      onProgress: (progress) =>
        onPatch(file.id, { progress, status: UploadStatus.UPLOADING }),
      onDocumentIdGenerated: (documentId) => onIdGenerated(file.id, documentId),
    });
    onPatch(file.id, { progress: 100, status: UploadStatus.SUCCESS });
    return { succeeded: true };
  } catch {
    onPatch(file.id, { status: UploadStatus.ERROR, errorMessage });
    return { succeeded: false };
  }
};
